import { DigitalClockTheme } from '../../types';

export const DIGITAL_CLOCK_DEFAULT_THEME: DigitalClockTheme = {
    height: 260,
    section: {
        paddingX: {
            default: 12,
            wide: 24,
        },
        paddingY: 12,
        itemSpacing: 2,
    },
    button: {
        width: 48,
        height: 40,
        typographyVariant: 'body.s',
        fontWeight: 'semiBold',
        radius: 6,
        colors: {
            background: 'transparent',
            backgroundHover: 'primary.tint.100',
            backgroundActive: 'primary.base',
            backgroundActiveHover: 'primary.tint.500',
            text: 'common.black',
            textActive: 'common.white',
        },
    },
};
